export { default } from './ProductAccordionItem'
